module.exports = __webpack_public_path__ + "img/36.9a5595b8.jpg";